export let recipe = {
  ingredients: [
    // NOTE: ingredient names should be unique
    {
      name: 'White Bread Flour',
      qty: 300,
      type: 'flour',
    },
    {
      name: 'Whole Wheat Flour',
      type: 'flour',
      qty: 100,
    },
    {
      name: 'Water',
      qty: 300,
      type: 'liquid',
    },
    {
      name: 'Salt',
      type: 'salt',
      qty: 8,
    },
    {
      name: 'Levain',
      type: 'preferment',
      qty: 80,
      hydration: 1,
    },
    // {
    //   name: 'Spelt flour',
    //   type: 'flour',
    //   qty: 100,
    // },
  ],
  numLoaves: 1,
  title: 'Peasant Loaf',
  description: 'My go-to weekday loaf. 25% whole wheat and just enough water.',
};

export const cleanRecipe = {
  ingredients: [
    // NOTE: ingredient names should be unique
    {
      name: 'White Bread Flour',
      qty: 300,
      type: 'flour',
    },
    {
      name: 'Whole Wheat Flour',
      type: 'flour',
      qty: 100,
    },
    {
      name: 'Water',
      qty: 300,
      type: 'liquid',
    },
    {
      name: 'Salt',
      type: 'salt',
      qty: 8,
      units: 'g',
    },
    {
      name: 'Levain',
      type: 'preferment',
      qty: 80,
      hydration: 1,
    },
    // {
    //   name: 'Spelt flour',
    //   type: 'flour',
    //   qty: 100,
    // },
  ],
};
